import $dataStr from 'fxdom/es/dataStr.js';
import { html, strMap } from 'fxjs/es';
import { htmlIf } from '@services/MarppleShop/shared/util/index.ts';
import { MembershipFilter } from '../../../../../Creator/Setting/S/MembershipFilter/MembershipFilter.ts';
import { messages } from '../../../../../Creator/Setting/S/messages_id.js';
import {
  makeEditableProductItemHtml,
  makeProductRevealingFilterHtml,
  makeProductRevealingFilterHtml2,
} from '../../../../../Creator/Setting/S/tmpl.js';
import { makePaginationHtml } from '../../../../../Pagination/S/tmpl.js';
import { UtilS } from '../../../../../Util/S/Function/module/UtilS.js';
import { StudioHeader } from '@services/MarppleShop/marppleShopStudioApp/components/cells/Layout/StudioTitle.ts';

export const root = ({
  is_store_deleted,
  store_products,
  pagination_state,
  total_product_count,
  ebook_categories,
  filter_state,
  need_confirm_action,
  store,
} = {}) => {
  const is_membership_project_exists = !!store.membership_project_id;

  return html`
    <div class="header flex">
      <div class="left real-pb-setting-title">
        ${new StudioHeader({
          title: UtilS.isMarppleShopApp()
            ? ET('mps2::studio::page::products_digital')
            : T(messages.menus.make_digital_products),
          description: UtilS.isMarppleShopApp()
            ? ET('mps2::studio::page::products_digital_guide')
            : T(messages.digital_products.p1),
          with_margin: false,
        }).toHtml()}
      </div>
      <div class="right product-filters flex-column">
        <div class="product-filters__filter">
          ${htmlIf(
            new MembershipFilter({ active: filter_state.only_membership }).toHtmlSSR(),
            MembershipFilter.isVisible(store.id) && is_membership_project_exists,
          )}
          ${makeProductRevealingFilterHtml(filter_state)}
          ${need_confirm_action ? makeProductRevealingFilterHtml2(filter_state) : ''}
        </div>
      </div>
    </div>
    <div class="body">
      <ul
        class="products digital_product_infos"
        data-total_product_count="${total_product_count}"
        data-is_store_deleted="${is_store_deleted}"
        data-fx-json="${$dataStr({ ebook_categories })}"
      >
        <li class="btn-create-product">
          <div class="wrap-content">
            <div class="plus-icon">
              <img
                src="//s3.marpple.co/files/u_1165777/2020/9/original/993035129b660d8b42e3a025bf5cae74a4d2e5421.png"
                alt="${T(messages.digital_products.p2)}"
              />
            </div>
            <div class="description">${T(messages.digital_products.p2)}</div>
          </div>
        </li>
        ${strMap(makeEditableProductItemHtml, store_products)}
      </ul>
      ${makePaginationHtml(pagination_state)}
    </div>
  `;
};
